import React, { useState, useEffect } from "react";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { useMediaQuery, useTheme } from "@mui/material";

// Import your RatingObject dialog
import RatingObject from "./RatingObject/RatingObject"; // adjust path as needed

const GlobalPlusButton = () => {
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // Listen for custom event to open dialog (from mobile bottom nav)
    useEffect(() => {
        const handleOpenDialog = () => {
            setOpen(true);
        };

        window.addEventListener('openPlusDialog', handleOpenDialog);

        return () => {
            window.removeEventListener('openPlusDialog', handleOpenDialog);
        };
    }, []);

    return (
        <>
            {/* Floating "+" button - hidden on mobile (controlled by bottom nav) */}
            {!isMobile && (
                <Fab
                    color="primary"
                    onClick={() => setOpen(true)}
                    sx={{
                        position: "fixed",
                        bottom: 20,       // <--- same level as AI button
                        right: 90,        // <--- positioned to the left of AI button
                        zIndex: 999999,   // ensure it stays above other elements
                    }}
                >
                    <AddIcon />
                </Fab>
            )}

            {/* RatingObject dialog opens when 'open' is true - only render when needed */}
            {open && <RatingObject
                open={open}
                handleClose={() => setOpen(false)}
                // Pass whatever props you need:
                isFeedback={false}
                id={null}
                onRateSuccessfully={() => {
                    // do something on success
                    setOpen(false);
                }}
            />}
        </>
    );
};

export default GlobalPlusButton;
